// NOTE: This is a draft legal text. Review by a legal professional is recommended.
import LegalPage from "@/components/LegalPage";
import { LEGAL_VERSIONS } from "@/lib/legalVersions";

export default function PrivacyPolicyEn() {
  return (
    <LegalPage
      lang="en"
      title="Privacy Policy"
      subtitle="How uSeen collects, uses and protects your personal data."
      lastUpdated="May 2026"
      version={LEGAL_VERSIONS.privacy}
      testid="privacy-page-en"
    >
      <h2>1. Who We Are</h2>
      <p>
        {"uSeen (\"we\", \"our\", \"us\") operates an AI visibility readiness and analysis platform. This policy explains how we handle personal data of users and visitors."}
      </p>

      <h2>2. Data We Collect</h2>
      <ul>
        <li><strong>Account data:</strong> name, email, hashed password, plan.</li>
        <li><strong>Business data:</strong> business name, website, sector, location and competitor websites you choose to add.</li>
        <li><strong>Usage data:</strong> pages visited, scans run, tasks completed — used to improve the product.</li>
        <li><strong>Technical data:</strong> IP address, browser type, device — used for security and rate-limiting.</li>
      </ul>

      <h2>3. How We Use Your Data</h2>
      <ul>
        <li>To deliver the AI visibility analysis and tasks you request.</li>
        <li>To maintain account security and prevent abuse.</li>
        <li>To improve the product, with analytics gated behind your consent.</li>
        <li>To communicate important service updates.</li>
      </ul>

      <h2>4. Sharing With Third Parties</h2>
      <p>
        We share the minimum data needed with carefully selected service
        providers (hosting, AI model providers, analytics). We do not sell your
        personal data to third parties.
      </p>

      <h2>5. International Transfers</h2>
      <p>
        Some service providers may process data outside your country. Where
        applicable, we rely on appropriate safeguards such as standard
        contractual clauses.
      </p>

      <h2>6. Your Rights</h2>
      <p>
        Depending on your jurisdiction (GDPR, KVKK, etc.) you may have the
        right to access, correct, delete or restrict processing of your
        personal data. Contact us to exercise these rights.
      </p>

      <h2>7. Data Retention</h2>
      <p>
        We keep personal data only for as long as needed to deliver the
        service, comply with legal obligations and resolve disputes.
      </p>

      <h2>8. Security</h2>
      <p>
        We apply industry-standard technical and organisational measures to
        protect your data. No method of transmission over the Internet is
        completely secure, but we work hard to minimise risk.
      </p>

      <h2>9. Contact</h2>
      <p>
        For privacy-related requests, reach us through the contact page.
      </p>
    </LegalPage>
  );
}
